module.exports = __webpack_public_path__ + "img/rosemary-pro.47412bb5.jpg";